export const LAYOUT_DATA = "LAYOUT_DATA";
export const REFETCH_LAYOUT = "REFETCH_LAYOUT";
export const DEFAULT_COLOR = "DEFAULT_COLOR";
export const DEFAULT_NAV_BAR_COLOR = "DEFAULT_NAV_BAR_COLOR";
export const TAB_MOTION = "TAB_MOTION";
export const MODAL_OPEN = "MODAL_OPEN";
export const PAYMENT_AMOUNT = "PAYMENT_AMOUNT";
export const DEBTOR_RIGHTS_MODAL = "DEBTOR_RIGHTS_MODAL";
export const ESIGN_MODAL = "ESIGN_MODAL";
export const ESIGN_MODAL_STORE = "ESIGN_MODAL_STORE";
export const DATE_FORMAT_LAYOUT = "DATE_FORMAT_LAYOUT";
export const IS_DISCOUNT_PERCENTAGE = "IS_DISCOUNT_PERCENTAGE";
export const IS_TAB_INVOICE = "IS_TAB_INVOICE";
export const IS_PAY_MULTI_OPTION = "IS_PAY_MULTI_OPTION";
export const IS_PAY_MULTI_OPTION_RESET = "IS_PAY_MULTI_OPTION_RESET";
export const IS_MULTI_MODAL_OPEN = "IS_MULTI_MODAL_OPEN";
export const IS_OPEN_BASED_TYPE = "IS_OPEN_BASED_TYPE";
export const IS_PAYMENT_PLAN_DATA = "IS_PAYMENT_PLAN_DATA";
export const IS_NSF_COUNT = "IS_NSF_COUNT";
export const tabMotionChange = (data) => {
  return {
    type: TAB_MOTION,
    payload: data,
  };
};

export const defaultColor = (data) => {
  return {
    type: DEFAULT_COLOR,
    payload: data,
  };
};

export const getLayoutData = (data) => {
  return {
    type: LAYOUT_DATA,
    payload: data,
  };
};
export const getDateFormat = (data) => {
  return {
    type: DATE_FORMAT_LAYOUT,
    payload: data,
  };
};

export const refetachLayoutData = () => {
  return {
    type: REFETCH_LAYOUT,
  };
};

export const modalSetFn = (data) => {
  return {
    type: MODAL_OPEN,
    payload: data,
  };
};

export const paymentAmount = (data) => {
  return {
    type: PAYMENT_AMOUNT,
    payload: data,
  };
};

export const setDebtorRightsModal = (data) => {
  return {
    type: DEBTOR_RIGHTS_MODAL,
    payload: data,
  };
};

export const setESignModal = (data) => {
  return {
    type: ESIGN_MODAL,
    payload: data,
  };
};

export const setESignModalStore = (data) => {
  return {
    type: ESIGN_MODAL_STORE,
    payload: data,
  };
};

export const isDiscountPercentage = (data) => {
  return {
    type: IS_DISCOUNT_PERCENTAGE,
    payload: data,
  };
};

export const isTabActiveInvoice = (data) => {
  return {
    type: IS_TAB_INVOICE,
    payload: data,
  };
};

export const isPayMultipleOption = (data) => {
  return {
    type: IS_PAY_MULTI_OPTION,
    payload: data,
  };
};

export const resetPayMultipleOption = () => {
  return {
    type: IS_PAY_MULTI_OPTION_RESET,
  };
};
export const setMultiModalOpen = (data) => {
  return {
    type: IS_MULTI_MODAL_OPEN,
    payload: data,
  };
};
export const setOpenBasedType = (data) => {
  return {
    type: IS_OPEN_BASED_TYPE,
    payload: data,
  };
};
export const setIsPayplanData = (data) => {
  return {
    type: IS_PAYMENT_PLAN_DATA,
    payload: data,
  };
};

export const setNSFCount = (data) => {
  return {
    type: IS_NSF_COUNT,
    payload: data,
  };
};
